import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getUserInfo } from '../../redux/selectors'
import { fetchContacts, saveDeactivate } from '../../redux/actions'
import DeactivateUsersComponent from './DeactivateUsersComponent'
import { requesterEmailAddress } from '../../libs/utils'
import { isEmpty } from 'lodash'

const DEFAULT_CONTACT = {
  name: '',
  emailAddress: '',
  removalReason: '',
  removalExplanation: ''
}

class DeactivateUsersContainer extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      contacts: [],
      contactsToDeactivate: [Object.assign({}, DEFAULT_CONTACT)],
      comments: ''
    }

    this.addContactToDeactivate = () => this.setState(prevState => (
      {contactsToDeactivate: [...prevState.contactsToDeactivate, Object.assign({}, DEFAULT_CONTACT)]}
    ))

    this.removeContactToDeactivate = contactIndex => () => this.setState(prevState => {
      const contacts = prevState.contactsToDeactivate.slice()
      contacts.splice(contactIndex, 1)
      return {contactsToDeactivate: contacts}
    })

    this.resetContactsToDeactivate = () => this.setState({contactsToDeactivate: [Object.assign({}, DEFAULT_CONTACT)]})
    this.resetGlobalComments = () => this.setState({comments: ''})

    this.updateContact = (index, field, value) => event => {
      const contacts = this.state.contactsToDeactivate.slice()
      const contact = Object.assign({}, contacts[index])
      contact[field] = value || event.target.value
      // clear email if changing name (email needs to be set again on click of user in suggestion list)
      if (field === 'name') contact.emailAddress = ''
      contacts[index] = contact
      return this.setState({contactsToDeactivate: contacts})
    }

    this.selectSuggestion = (index, email, name) => {
      const contacts = this.state.contactsToDeactivate.slice()
      const contact = Object.assign({}, contacts[index])
      contact.emailAddress = email
      contact.name = name
      contacts[index] = contact
      return this.setState({contactsToDeactivate: contacts})
    }

    this.updateGlobalComments = event => this.setState({comments: event.target.value})

    this.saveDeactivate = async event => {
      const emailAddress = requesterEmailAddress(this.props)

      const deactivateRequest = {
        emailAddress,
        reason: this.state.comments,
        contacts: this.state.contactsToDeactivate.map(contact => ({
          emailAddress: contact.emailAddress,
          reason: contact.removalExplanation || contact.removalReason
        }))
      }
      this.props.saveDeactivate(deactivateRequest)
    }
  }

  componentDidMount () {
    document.title = 'User Profile - Deactivate Users'
    const emailAddress = requesterEmailAddress(this.props)
    this.props.fetchContacts(emailAddress)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    return {
      contacts: Array.isArray(nextProps.contacts) && !isEmpty(nextProps.contacts) ? nextProps.contacts.sort((a, b) => (a.firstName || '').toUpperCase().localeCompare(b.firstName.toUpperCase())) : []
    }
  }

  render () {
    const { contacts, contactsToDeactivate, comments } = this.state
    return (
      <DeactivateUsersComponent
        contacts={contacts}
        contactsToDeactivate={contactsToDeactivate}
        comments={comments}
        addContactToDeactivate={this.addContactToDeactivate}
        removeContactToDeactivate={this.removeContactToDeactivate}
        resetContactsToDeactivate={this.resetContactsToDeactivate}
        updateContact={this.updateContact}
        selectSuggestion={this.selectSuggestion}
        updateGlobalComments={this.updateGlobalComments}
        resetGlobalComments={this.resetGlobalComments}
        saveDeactivate={this.saveDeactivate}
      />
    )
  }
}

DeactivateUsersContainer.propTypes = {
  emailAddress: PropTypes.string.isRequired,
  contacts: PropTypes.array
}

const mapStateToProps = state => ({
  emailAddress: getUserInfo(state).emailAddress,
  contacts: getUserInfo(state).contacts
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    fetchContacts,
    saveDeactivate
  }, dispatch)
)

const DeactivateUsersConnect = connect(mapStateToProps, mapDispatchToProps)(DeactivateUsersContainer)

export default DeactivateUsersConnect
